import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "install",
  "use": "install-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"install\"><path d=\"M9.5 18a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Z\" opacity=\".1\" /><path d=\"M10 12.962 13.679 9H15l-5.5 6L4 9h1.321L9 12.962V4h1z\" /><path d=\"M9.5 1a8.5 8.5 0 1 1 0 17 8.5 8.5 0 0 1 0-17Zm0 1a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol